import Icon from '../components/Icon.vue'

Icon.register({
  'file-excel': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM284.1 242.5c5.1-8-0.6-18.5-10.1-18.4h-34.8c-4.4 0-8.5 2.4-10.6 6.3-30.5 56.8-36.6 68.5-36.6 68.5-16.6-34.9-10.5-19.7-36.6-68.5-2.1-3.9-6.2-6.3-10.6-6.3h-34.8c-9.5 0-15.3 10.5-10.1 18.5l60.3 93.5-60.3 93.5c-5.1 8 0.6 18.5 10.1 18.5h34.9c4.4 0 8.4-2.4 10.5-6.3 26.6-48.8 30.2-54 36.6-68.8 0 0 16.9 32.5 36.5 68.7 2.1 3.9 6.2 6.3 10.6 6.3h34.9c9.5 0 15.2-10.5 10.1-18.5l-60.1-93.5zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'
      }
    ]
  }
})
